import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EIntakeType } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { EField, IExtraData } from "./schema.tenantProfileBroker.types";

export const getInitialValues = ({ broker }: IExtraData): IValues => {
  return {
    [EField.IntakeMail]: broker.intakeMail || undefined,
    // This fallback does not decide anything for a new account, despite how it
    // reads: legacy's broker model gives intakeType a default on create
    // (broker.json), so the field is never absent and this branch never runs.
    // Left in place as a defensive default only.
    //
    // That legacy default is now 3 as well, so the two agree: it was raised
    // from 1 in rentio-api-legacy 835c6337c on 2026-09-03, which is the other
    // half of DEV-3065. Before that a new broker started on the two-step flow
    // while this line suggested otherwise.
    [EField.IntakeType]: broker.intakeType ?? EIntakeType.TwoPhasesWithVisit,
  };
};
